import Step0IntakeContact from './steps/Step0_IntakeContact'
import Step1InjuredParty from './steps/Step1_InjuredParty'
import Step2ExploitationDetails from './steps/Step2_ExploitationDetails'
import Step3LegalVerification from './steps/Step3_LegalVerification'
import Step6DriverLicenseUpload from './steps/Step6_DriverLicenseUpload'
import Step7ProofOfScreenshots from './steps/Step7_ProofOfScreenshots'
import Step8Submit from './steps/Step8_Submit'
import Step9Signature from './steps/Step9_Signature'
import Step10FollowUp from './steps/Step10_FollowUp'
import { ROBLOX_CAMPAIGN_NAME, ROBLOX_CAMPAIGN_TYPE } from './constants'
import { ROBLOX_CAMPAIGN_CONFIG } from './config/roblox.config'
import type { CampaignRegistry } from '../campaignRegistry.types'

export const robloxComponents = {
  Step0_IntakeContact: Step0IntakeContact,
  Step1_InjuredParty: Step1InjuredParty,
  Step2_ExploitationDetails: Step2ExploitationDetails,
  Step3_LegalVerification: Step3LegalVerification,
  Step6_DriverLicenseUpload: Step6DriverLicenseUpload,
  Step7_ProofOfScreenshots: Step7ProofOfScreenshots,
  Step8_Submit: Step8Submit,
  Step9_Signature: Step9Signature,
  Step10_FollowUp: Step10FollowUp,
  // Backwards compatibility with legacy component keys
  RobloxIntakeContact: Step0IntakeContact,
  RobloxExploitationDetails: Step2ExploitationDetails,
  RobloxLegalVerification: Step3LegalVerification,
  EmergencyNotes: Step7ProofOfScreenshots,
  IdentityPreview: Step6DriverLicenseUpload,
  Submit: Step8Submit,
  Signature: Step9Signature,
  FollowUp: Step10FollowUp,
}

const identifiers = [
  ROBLOX_CAMPAIGN_TYPE,
  ROBLOX_CAMPAIGN_NAME,
  ...(ROBLOX_CAMPAIGN_CONFIG?.campaignNames || []),
]

export const robloxRegistry: CampaignRegistry = {
  type: ROBLOX_CAMPAIGN_TYPE,
  identifiers,
  stages: [], 
  components: robloxComponents,
}

